module.exports = __webpack_public_path__ + "img/kistimldms_01.a1c1aa50.png";